import errorScreenView from './errorScreenComponent.html';
import './errorScreenComponent.css';

export function errorScreenComponent() {
	return {
		bindings: {
			class: '<',
			image: '<?',
			title: '<',
			message: '<',
			actionText: '<',
			blockHiding: '<',
			actionUrl: '<?',
			detailsText: '<',
			actionCallback: '&?',
			onClose: '&?',
		},
		controllerAs: 'vm',
		controller: errorScreenComponentCtrl,
		template: errorScreenView,
	};
}

export class errorScreenComponentCtrl {
	constructor($scope, $element) {
		'ngInject';
		this.$scope = $scope;
		this.$element = $element;

		if (!this.image && this.class) {
			this.image = `/angular/assets/img/errors/${this.class}.svg`;
		}

		if (/screensaver/i.test(navigator.userAgent)) {
			setTimeout(() => {
				window.location.reload();
			}, 10000);
		}
	}

	$onInit() {
		// remove title attribute so that the screen doesn't
		// show the title tooltip on mouseover
		this.$element.attr('title', '');
	}

	doAction($event) {
		if (!this.blockHiding) {
			this.close();
		}
		if (this.actionCallback) {
			this.actionCallback({ $event });
		}
	}

	close() {
		this.$scope.$destroy();
		this.$element.remove();
		this.onClose && this.onClose();
	}

	toggleDetails() {
		this.showDetails = !this.showDetails;
	}
}
